// Social_Media_Account_Modal.jsx
import { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Switch } from "@/config/antd";
import { CloseOutlined } from "@/config/antd";
import WebIcon from "@/components/common/Web_Icons";

const SocialMediaAccountModal = ({ isVisible, onClose }) => {
  const [socialAccounts, setSocialAccounts] = useState({
    facebook: false,
    google: false,
  });

  const socialOptions = [
    {
      id: "facebook",
      title: "Facebook",
      icon: "Facebook",
    },
    {
      id: "google",
      title: "Google",
      icon: "Google",
    },
  ];

  const handleToggle = (accountId) => {
    setSocialAccounts((prev) => ({
      ...prev,
      [accountId]: !prev[accountId],
    }));
  };

  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      centered
      width={500}
      closeIcon={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          borderRadius: "16px",
          overflow: "hidden",
        },
        mask: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
      }}>
      <div className="flex flex-col bg-white">
        {/* Header */}
        <div className="p-4 flex items-center justify-between border-b border-gray-200">
          <h2 className="text-bold-x text-primary">
            Connected Social Accounts
          </h2>
          <CloseOutlined
            onClick={onClose}
            className="cursor-pointer"
            style={{
              color: "var(--veegil-color-primary)",
              backgroundColor: "var(--veegil-color-secondary)",
              borderRadius: "50%",
              padding: "4px",
            }}
          />
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="space-y-4">
            {socialOptions.map((option) => (
              <div
                key={option.id}
                className="flex items-center justify-between p-4 bg-white rounded-lg transition-all duration-300">
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 flex items-center justify-center">
                    <WebIcon icon={option.icon} className="w-[50px] h-[50px]" />
                  </div>
                  <span className="text-bold text-black">{option.title}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Switch
                    checked={socialAccounts[option.id]}
                    onChange={() => handleToggle(option.id)}
                    checkedChildren={
                      <span style={{ color: "var(--veegil-color-primary)" }}>
                        Active
                      </span>
                    }
                    unCheckedChildren="Inactive"
                    className="bg-secondary"
                    style={{
                      "--ant-primary-color": "var(--veegil-color-primary)",
                      minWidth: "80px",
                      backgroundColor: socialAccounts[option.id]
                        ? "var(--veegil-color-dark-blue)"
                        : "var(--veegil-color-secondary)",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

SocialMediaAccountModal.propTypes = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SocialMediaAccountModal;
